import React from 'react';
import ReactDOM from 'react-dom/client';
import AuthService from 'services/auth/AuthService';
import App from './App';
import 'index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const renderApp = () =>
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );

AuthService.initAuth(renderApp);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
